import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FirebaseAnalyticsService } from 'firebase-analytics';
import { combineLatest } from 'rxjs';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { Parent } from '../../../../../models/parent';
import { ProfileInfo } from '../../../../../models/profile-info';
import { UserService } from '../../../../../services/user/user-service/user.service';
import { pages } from '../../../../../utils/pages';
import { StudentProfileInfo } from '../../models/student-profile-info';
import { StudentProfileService } from '../../services/student-profile.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent extends ComponentBase implements OnInit {

  constructor(private userService: UserService
    , private studentProfileService: StudentProfileService
    , private route: ActivatedRoute
    , private firebaseAnalyticsService: FirebaseAnalyticsService) {
    super();
  }

  profileInfo: ProfileInfo;
  studentInfo: StudentProfileInfo;
  userInfo: Parent;
  showMyProfile: boolean = true;
  option: string;
  public config: PerfectScrollbarConfigInterface = {};

  ngOnInit() {
    this.firebaseAnalyticsService.logPageView(pages.myAccount);
    let sub1 = this.route.params.subscribe(params => {
      this.option = params.option;
    });
    this.addSubscription(sub1);
    let subscription = combineLatest(this.userService.getLoggedInUser(), this.studentProfileService.getProfileInfo())
      .subscribe(res => {
        this.profileInfo = res[0];
        this.studentInfo = res[1];
        this.userInfo = this.studentInfo.parents_info.find(o => o.person_id == this.profileInfo.person.person_id);
        if (!this.userInfo) {
          this.option = 'student';
        }
      });
    this.addSubscription(subscription);
  }

  switchProfileView() {
    this.showMyProfile = !this.showMyProfile;
  }
}
